var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrap"},[_c('div',{staticStyle:{"width":"100%","height":"auto","padding":"7px 13x","overflow":"hidden"}},[_c('img',{staticStyle:{"width":"100%","height":"auto","display":"block"},attrs:{"src":_vm.logo}})])])}
var staticRenderFns = []

export { render, staticRenderFns }